import React from 'react';
import DataTableRow from "../components/DataTableRow";
export default function rowRenderer(props, data, idx, isBulk) {
  var displayPreferences = props.displayPreferences,
      cellRenderers = props.cellRenderers,
      rowSelections = props.rowSelections,
      tableMetadata = props.tableMetadata,
      onRowClick = props.onRowClick,
      onRowSelect = props.onRowSelect,
      controlsColumnWidth = props.controlsColumnWidth,
      renderActions = props.renderActions,
      onPreviewClick = props.onPreviewClick,
      shouldRenderPreviewIcon = props.shouldRenderPreviewIcon,
      checkable = props.checkable,
      multi = props.multi,
      allowSelectionOnRowClick = props.allowSelectionOnRowClick,
      getTableRef = props.getTableRef;
  var _data$rowOptions = data.rowOptions;
  _data$rowOptions = _data$rowOptions === void 0 ? {} : _data$rowOptions;
  var disabled = _data$rowOptions.disabled,
      hideActions = _data$rowOptions.hideActions,
      hidePreview = _data$rowOptions.hidePreview;
  return React.createElement(DataTableRow, {
    key: idx,
    idx: idx,
    data: data,
    controlsColumnWidth: controlsColumnWidth,
    checkable: checkable,
    multi: multi,
    onPreviewClick: onPreviewClick,
    shouldRenderPreviewIcon: shouldRenderPreviewIcon,
    hidePreview: hidePreview,
    onRowSelect: onRowSelect,
    isDisabled: disabled,
    isSelected: rowSelections[idx],
    isBulk: isBulk,
    preferences: displayPreferences,
    renderActions: renderActions,
    hideActions: hideActions,
    cellRenderers: cellRenderers,
    tableMetadata: tableMetadata,
    onRowClick: onRowClick,
    allowSelectionOnRowClick: allowSelectionOnRowClick,
    getTableRef: getTableRef
  });
}